import styled, { css } from 'styled-components';
import {TWO_LINES_TITLE} from '../../../css-constants';

export const GameTitleDefaultBox = styled.div<{hasTwoLinesTitle?: boolean}>`
    text-align: center;
    color: ${props => props.theme.colors.backgroundContrast};
    opacity: 1;
    font-size: 1.4rem;
    line-height: normal;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    direction: initial;
    padding-bottom: 2px;

    &.${TWO_LINES_TITLE} {
        ${props => props.hasTwoLinesTitle ? css`
            width: 100%;
        `
        : css`
            max-width: 90%;
        `};

        white-space: initial;
    }
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 1.2rem;
        padding-bottom: 0;
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        font-size: 0.9rem;
    }
`;

